export const getUserLanguage = (): string => {
  const primaryLanguage = navigator.language || navigator.userLanguage || '';
  if (primaryLanguage.toLowerCase().startsWith('ja')) {
    return 'ja';
  }
  const languages = navigator.languages || [];
  for (const lang of languages) {
    if (lang.toLowerCase().startsWith('ja')) {
      return 'ja';
    }
  }
  return 'en';
};
